<template>
  <v-card min-height="550">
    <v-toolbar flat width="100%">
      <v-toolbar-title class="text-capitalize title">{{ $t("animal.healthRecordInfo.vaccination") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="vaccination && vaccination.length > 0" @click="showAddVaccinationDialog('edit')" outlined
        right height="50" width="241" color="primary">
        {{ $t('editCurrentRecord') }}
      </v-btn>
      <v-btn @click="showAddVaccinationDialog('add')" right class="ml-5" height="50" width="241" color="primary"
        type="submit">
        {{ $t('addNewRecord') }}
      </v-btn>
    </v-toolbar>
    <v-row width="100%">
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                >{{ $t("animal.healthRecordInfo.vaccinationType") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      Vaccines are made using several processes. They may contain live viruses that have been attenuated (weakened or altered to not cause illness); inactivated or killed organisms or viruses; inactivated toxins (for bacterial diseases where toxins generated by the bacteria, and not the bacteria themselves, cause illness); or merely segments of the pathogen (this includes both subunit and conjugate vaccines). The different vaccine types each require different development techniques.
                    </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      vaccinationData && vaccinationData.vaccinationType
                      ? vaccinationData.vaccinationType
                      : "Not Specified"
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
          class="
          mt-n6
          mb-n2
          text-overline
          font-weight-light
          text-end text--secondary
          "
          >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.vaccinationName") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      It is the trade name of vaccine used for administration. e.g. biothrax, vaxchora etc.
                    </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      vaccinationData && vaccinationData.vaccinationName
                        ? vaccinationData.vaccinationName
                        : "Not Specified"
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.vaccinationAge") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      Date of Manufacture
                    </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      vaccinationData && vaccinationData.vaccinationAge
                        ? vaccinationData.vaccinationAge
                        : "Not Specified"
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.immunityAfterVaccination") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.healthRecordInfo.immunityAfterVaccination")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      vaccinationData && vaccinationData.immunityAfterVaccination
                        ? vaccinationData.immunityAfterVaccination
                        : "Not Specified"
                    }}
                    {{
                      vaccinationData && vaccinationData.immunityAfterVaccinationUnit
                        ? vaccinationData.immunityAfterVaccinationUnit
                        : ""
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.immunityLastingPeriod") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      How many days the animal will be immunized after vaccination e.g. 180 days, 200 days, 1 year etc
                    </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      vaccinationData && vaccinationData.immunityLastingPeriod
                        ? vaccinationData.immunityLastingPeriod
                        : "Not Specified"
                    }}
                    {{
                      vaccinationData && vaccinationData.immunityLastingPeriodUnit
                        ? vaccinationData.immunityLastingPeriodUnit
                        : ""
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.vaccineRouteOfAdmin") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      The location at which the drug is administered e.g. oral, subcutaneous, intramuscular
                    </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      vaccinationData && vaccinationData.vaccineRouteOfAdmin
                        ? vaccinationData.vaccineRouteOfAdmin
                        : "Not Specified"
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.vaccinationDosage") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      Its is the amount of vaccine administered to the animal e.g. 0.5ml, 2ml, 5ml etc
                    </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      vaccinationData && vaccinationData.vaccinationDosage
                        ? vaccinationData.vaccinationDosage
                        : "Not Specified"
                    }}
                    {{
                      vaccinationData && vaccinationData.vaccinationDosageUnit
                        ? vaccinationData.vaccinationDosageUnit
                        : ""
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.revaccinationTime") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      Date for booster dose
                    </span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      vaccinationData && vaccinationData.revaccinationDate
                        ? vaccinationData.revaccinationDate
                        : "Not Specified"
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.vaccinationDate") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.healthRecordInfo.vaccinationDate")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      vaccinationData && vaccinationData.vaccinationDate
                        ? vaccinationData.vaccinationDate
                        : "Not Specified"
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ $t("animal.healthRecordInfo.administratorName") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.healthRecordInfo.administratorName")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      vaccinationData && vaccinationData.administratorName
                        ? vaccinationData.administratorName
                        : "Not Specified"
                    }}
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
    </v-row>

    <div class="mt-7">
      <span style="font-size: 20px">
        Vaccination History
      </span>
      <v-data-table class="mt-7" :headers="headers" :items="getVaccinations" :items-per-page="20" hide-default-footer
        :loading="loading" loading-text="Loading Data...">

        <template #item.vaccinationAge="{ item }">{{ item.vaccinationAge ? formatDate(item.vaccinationAge) : ''}}</template>
        <template #item.immunityAfterVaccination="{ item }">{{ item.immunityAfterVaccination }} {{ item.immunityAfterVaccinationUnit }}</template>
        <template #item.immunityLastingPeriod="{ item }">{{ item.immunityLastingPeriod }} {{ item.immunityLastingPeriodUnit }}</template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-icon small @click="editVaccination(item)">
              mdi-pencil
            </v-icon>
            <v-icon small color="red" @click="deleteVaccination(item)">
              mdi-delete
            </v-icon>
          </div>

        </template>
        <template v-slot:footer></template>
      </v-data-table>
    </div>
    <VaccinationDialog
      @closeDialog="closeDialog"
      @onUpdate="onVaccinationUpdate"
      :dialogI="showVaccinationDialog"
      :vaccinationItem="vaccinationItem"
      v-if="showVaccinationDialog"
    />
    <DeletePopup :dialogI="showDeleteDialog" v-if="showDeleteDialog" @delete="onDelete" @closeDialog="closeDeleteDialog" />
  </v-card>
</template>

<script>
import gql from "graphql-tag";

import generalMixin from "@/mixins/GeneralMixin"

import DeletePopup from "../DeletePopup.vue";
import VaccinationDialog from './VaccinationDialog.vue';

export default {
  components: {
    DeletePopup,
    VaccinationDialog,
  },
  computed: {
    getVaccinations() {
      return this.vaccination.slice(1);
    },
    headers() {
      return [
        {
          text: "Type of Vaccination",
          align: "start",
          value: "vaccinationType",
        },
        { text: "Name of Vaccination", value: "vaccinationName" },
        { text: "Vaccination Age", value: "vaccinationAge" },
        { text: "Immunity Development After Vaccination", value: "immunityAfterVaccination" },
        { text: "Immunity Lasting Period", value: "immunityLastingPeriod" },
        { text: '', value: 'actions', sort: 'false', class: 'd-flex' },
      ];
    },
  },
  data() {
    return {
      loading: false,
      showVaccinationDialog: false,
      showDeleteDialog: false,
      vaccinationData: this.vaccination[0],
      vaccinationItem: {},
    }
  },
  methods: {
    onVaccinationUpdate() {
      this.$emit('vaccination:updated');
    },
    closeDialog() {
      this.showVaccinationDialog = false
      this.vaccinationItem = null
    },
    editVaccination(item) {
      this.vaccinationItem = item
      this.showVaccinationDialog = true;
    },
    showAddVaccinationDialog(action) {
      if (action == 'edit') {
        this.vaccinationItem = this.vaccinationData
      } else {
        this.vaccinationItem = null;
      }
      this.showVaccinationDialog = true;
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false
      this.vaccinationItem = null
    },
    async onDelete() {
      await this.$apollo
        .mutate({
          mutation: gql`
                    mutation removeVaccination($id: Int!) {
                      removeVaccination(id: $id)
                    }
                  `,
          variables: {
            id: parseInt(this.vaccinationItem.id),
          },
        })
      this.showDeleteDialog = false
      this.$emit('vaccination:updated');
    },
    deleteVaccination(item) {
      this.showDeleteDialog = true
      this.vaccinationItem = item
    },
  },
  mixins: [generalMixin],
  mounted() {
    this.vaccinationData = Object.assign({}, this.vaccination[0]);
  },
  props: {
    vaccination: {
        required: true,
        type: Array,
    }
  }
}
</script>
